import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";

import { AppProvider } from "@/context/AppContext";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import Cursor from "@/components/Cursor";
import LoadingScreen from "@/components/LoadingScreen";
import ScrollProgress from "@/components/ScrollProgress";

import Home from "@/pages/Home";
import CollectionDetail from "@/pages/CollectionDetail";
import AllCollections from "@/pages/AllCollections";
import Personalities from "@/pages/Personalities";
import Personality from "@/pages/Personality";
import Story from "@/pages/Story";
import Wishlist from "@/pages/Wishlist";
import WhySolPage from "@/pages/WhySolPage";
import FAQPage from "@/pages/FAQPage";
import Quiz from "@/pages/Quiz";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  return null;
}

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <ScrollToTop />
        <LoadingScreen />
        <ScrollProgress />
        <Cursor />
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/collections" element={<AllCollections />} />
            <Route path="/collection/:slug" element={<CollectionDetail />} />
            <Route path="/personalities" element={<Personalities />} />
            <Route path="/personality/:slug" element={<Personality />} />
            <Route path="/story" element={<Story />} />
            <Route path="/why-sol" element={<WhySolPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/wishlist" element={<Wishlist />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
